import React from "react";

import { Typography, LinearProgress, Theme } from "@material-ui/core";
import { withStyles, createStyles } from "@material-ui/styles";

const BorderLinearProgress = withStyles((theme: Theme) => createStyles({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: "#CCCCCC",
    },
    bar: {
      borderRadius: 5,
      backgroundColor: "#0059E2",
    },
  })
)(LinearProgress);

export const CommonLinearProgress = ({
  label,
  value,
}: any) => (
  <>
    <Typography
      variant="h2"
      color="textSecondary"
      className="common-linear-progress"
    >
      {label} {value}%
    </Typography>

    <BorderLinearProgress
      value={value}
      variant="determinate"
    />
  </>
)